import fetch from '@/utils/fetch';

export function getUpload() {
    let params = new URLSearchParams();
    return fetch({
        url: '/common/getWxCosFile',
        method: 'post',
        data:params
    });
}

// 根据字典code获得字典数据
export function findDicsByCode(args) {
    let params = new URLSearchParams();
    params.append('dicCode', args.dicCode);

    return fetch({
        url: 'structure/sysDictionary/findDicsByCode',
        method: 'post',
        data:params
    });
}

// 获取点播的secretId和secretKey
export function getSecretKey(args) {
    let params = new URLSearchParams();

    return fetch({
        url: 'common/getSecretKey',
        method: 'post',
    });
}

// 获取视频详情
export function getVodInfo(args) {
    let params = new URLSearchParams();
    params.append('fileId', args.fileId);

    return fetch({
        url: 'common/getVodInfo',
        method: 'post',
        data: params
    });
}

// 删除视频
export function deleteVod(args) {
    let params = new URLSearchParams();
    params.append('fileId', args.fileId);

    return fetch({
        url: 'common/deleteVod',
        method: 'post',
        data: params
    });
}

export function getWxCosFileSign(filePath) {
    let params = new URLSearchParams();
    params.append('filePath', filePath);
    return fetch({
        baseURL: global.BasePath,
        url: 'common/getWxCosFileSign',
        method: 'get',
        params
    });
}
// 获取云点播签名
export function getSignature() {
    return fetch({
        baseURL: global.BasePath,
        url: 'common/getSignature',
        method: 'GET'
    });
}



// WEBPACK FOOTER //
// ./src/api/common/common.js